import { useState, useEffect } from "react";
import SimpleTextField from "./SimpleTextField";
import LanguageValueField from "./LanguageValueField";
import LanguageValueList from "../formModels/LanguageValueList";
// import AdmsIdentifierListView from "./AdmsIdentifierListView";
import { Typography, Stack } from "@mui/material";
import { isFieldRequired, getTitleByField, getDescriptionByField } from "../config/commonFunctions";
import Person from "../formModels/Person";
// import AdmsIdentifierList from "../formModels/AdmsIdentifierList";

export default function PersonSingle(props) {
    const [person, setPerson] = useState(props.initialPerson);
    const { required, schemaAsObject } = props; // error, validationError
    // console.log(validationError?.email);

    useEffect(() => {
        if (props.initialPerson) {
            setPerson(props.initialPerson);
        } else {
            setPerson(new Person());  // Initialize with an empty Person object if missing
        }
    }, [props.initialPerson]);

    // Update function for street address field
    const handleNameChange = (updatedValues) => {
        if (updatedValues instanceof LanguageValueList) {
            const updatedPerson = new Person(
                updatedValues,
                person.getEmails(),
                person.getId()
            );
            setPerson(updatedPerson);
            props.onChange(updatedPerson); // Pass the updated person back to parent
        }
    };

    // Handle emails change
    const handleEmailsChange = (updatedEmails) => {
        // Create a copy of the person instance and update emails
        const updatedPerson = new Person(
            person.getName(),
            updatedEmails,
            person.getId(),
        );
        setPerson(updatedPerson);
        props.onChange(updatedPerson); // Pass the updated person back to parent
    };
    // console.log(schemaAsObject);
    return (
        <Stack spacing={2}>
            <fieldset>
                <legend>
                    <div>
                        <Typography variant="h4">{props.title} {required && <span>*</span>} </Typography>
                        <Typography variant="h5">{props.subtitle}</Typography>
                    </div>
                </legend>
                <Stack spacing={4}>
                    <LanguageValueField
                        id={`${props.title}-name`}
                        label={getTitleByField(schemaAsObject, "Person.name")}
                        helperText={getDescriptionByField(schemaAsObject, "Person.name")}
                        obj={person.getName()}
                        lang={props.lang}
                        onChange={handleNameChange}
                        required={props.requirementException === false ? isFieldRequired("name", schemaAsObject?.$defs?.Person) : false}
                    // error={error ? !!error.name : false}
                    />

                    <SimpleTextField
                        label={getTitleByField(schemaAsObject, "Person.email")}
                        helperText={getDescriptionByField(schemaAsObject, "Person.email")}
                        value={person.getEmails()}
                        onChange={handleEmailsChange}
                        required={required ? isFieldRequired("email", schemaAsObject?.$defs?.Person) : false}
                    />
                </Stack>
            </fieldset>
        </Stack>
    );
}
